import { CSRF } from '../utils/CSRF'
import { BaseRepository } from './BaseRepository'

export class TermSubstitutionRepository extends BaseRepository {
  add(team: string, original: string, substitution: string) {
    return super.getHttpClientInstance().post(
      `/teams/${team}/term_substitutions.json`,
      {
        term_substitution: {
          pair_original: original,
          pair_substitution: substitution,
        },
      },
      {
        'X-CSRF-Token': CSRF.getToken(),
      },
    )
  }

  delete(team: string, termSubstitutionId: number | string) {
    return super.getHttpClientInstance().delete(`/teams/${team}/term_substitutions/${termSubstitutionId}.json`, {
      'X-CSRF-Token': CSRF.getToken(),
    })
  }

  all(team: string) {
    return super.getHttpClientInstance().get(`/teams/${team}/term_substitutions.json`)
  }

  update(team: string, termSubstitutionId: number | string, original: string, substitution: string) {
    return super.getHttpClientInstance().patch(
      `/teams/${team}/term_substitutions/${termSubstitutionId}.json`,
      {
        term_substitution: {
          pair_original: original,
          pair_substitution: substitution,
        },
      },
      {
        'X-CSRF-Token': CSRF.getToken(),
      },
    )
  }
}
